import { AuthProvider } from '@tedsinc/teds-components/types/src/tedsUI/auth/providers/authProvider'
import { CoreConfigurationDto } from '@tedsinc/teds-server/dist/src/resources/v1/core/configuration/coreConfigurationSchema'
import { HttpSettings } from '../httpSettings/HttpSettings'
import { createRequestFromAuthAndSettings } from '../user/whoAmI'

/** Mock of core configuration response from server with all features enabled */
export const testCoreConfiguration: CoreConfigurationDto = {
  featuresEnabledForUser: {
    jobVisionModule: true,
    launcherUi: true,
    successionModule: true,
  },
}

/** Get the core configuration from the server */
export const getCoreConfiguration = async (
  httpSettings: HttpSettings,
  auth?: AuthProvider<unknown>
): Promise<CoreConfigurationDto> => {
  const request = createRequestFromAuthAndSettings(httpSettings, auth)
  try {
    const response = await request.get<CoreConfigurationDto>('/api/v1/core/configuration')
    if (response.status !== 200) {
      throw new Error('Could not get core configuration')
    }
    return response.data
  } catch (e) {
    if (e instanceof Error) {
      throw new Error(e.message)
    }
    throw new Error('Could not get core configuration')
  }
}
